import { useState } from 'react';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { UserProvider, useUser } from './contexts/UserContext';
import { PostProvider } from './contexts/PostContext';
import { MessageProvider } from './contexts/MessageContext';
import PostFeed from './components/Post/PostFeed';
import ChatList from './components/Message/ChatList';
import ProfileEditor from './components/Profile/ProfileEditor';

function Header({ activeTab, onTabChange }) {
  const { dark, toggle } = useTheme();
  const { user } = useUser();

  const tabs = [
    { id: 'feed', label: '广场', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    { id: 'messages', label: '私信', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
    { id: 'profile', label: '我的', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
  ];

  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="header-logo">
          <span className="logo-icon">🎯</span>
          <span className="logo-text">兴趣圈子</span>
        </div>

        <nav className="header-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => onTabChange(tab.id)}
            >
              <svg viewBox="0 0 24 24" width="20" height="20" className="nav-icon">
                <path d={tab.icon} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="nav-label">{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="header-actions">
          <button className="theme-toggle" onClick={toggle} title={dark ? '切换亮色' : '切换暗色'}>
            {dark ? (
              <svg viewBox="0 0 24 24" width="20" height="20">
                <circle cx="12" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>

          <div className="header-user">
            {user.avatar ? (
              <img src={user.avatar} alt="" className="header-avatar" />
            ) : (
              <div className="header-avatar-placeholder">
                {(user.name || '?')[0]}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

function AppContent() {
  const [activeTab, setActiveTab] = useState('feed');

  return (
    <div className="app">
      <Header activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="app-main">
        {activeTab === 'feed' && <PostFeed />}
        {activeTab === 'messages' && <ChatList />}
        {activeTab === 'profile' && <ProfileEditor />}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <UserProvider>
        <PostProvider>
          <MessageProvider>
            <AppContent />
          </MessageProvider>
        </PostProvider>
      </UserProvider>
    </ThemeProvider>
  );
}
